module.exports = __webpack_public_path__ + "img/bannerIIII.30b9b957.png";